module.exports = __webpack_public_path__ + "img/compelling.0732dd10.svg";